import { createSvgIcon } from "@mui/material/utils";
import React from "react";

const IconRadio = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 9.99484C19.5 15.1961 15.1954 19.5 10.0052 19.5C4.81423 19.5 0.5 15.1954 0.5 9.99484C0.5 4.80425 4.80425 0.5 9.99484 0.5C15.1861 0.5 19.5 4.80492 19.5 9.99484Z"
      fill="white"
      stroke="currentColor"
    />
  </svg>,
  "IconRadio",
);

export default IconRadio;
